import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import AutoCompleteProductCard from './ProductCards/AutoCompleteProductCard';

const sameCategory = (item, index, array) =>
    (index > 0 && array[index - 1].category === array[index].category) ||
    item.showAll;


const resultRenderer = (result, selectedItem, searchUrl) => {
    return (
        result.map((item, index, array) => (
            <Fragment key={`${item.name}-${index}`}>         
                {item.category === translate('quicksearchcat.products')
                    ?
                        <AutoCompleteProductCard  item={item}/>
                    :
                    <>
                    {item.url ? 
                    <>
                    {sameCategory(item, index, array) ? null : (
                        <li className="quick-search-result__item quick-search-result__group-header">
                            {item.category}
                        </li>
                    )}
                    <li
                        className={`quick-search-result__item ${
                            selectedItem === index
                                ? 'quick-search-result__item--selected'
                                : ''
                        }`}
                    >
                        <a
                            className={
                                item.showAll
                                    ? 'quick-search-result__show-all'
                                    : `quick-search-result__link ${
                                        item.url
                                            ? ''
                                            : 'quick-search-result__link--disabled'
                                    }`
                            }
                            href={item.showAll ? searchUrl : item.url}
                        >
                            <div>{item.name}{item.category === translate('quicksearchcat.manuals') ? <i className="far fa-file-pdf"></i> : null}</div>
                        </a>
                    </li>
                    </>
                    : null }
                    </>
                }
            </Fragment>
        )) 
    );
}

const QuickSearchResult = ({ groupedResult, selectedItem, isCampaignBannerActive, searchUrl }) => {

    let productResult = groupedResult[translate('quicksearchcat.products')];
    let categoryResult = groupedResult[translate('quicksearchcat.categories')];
    let manualsResult = groupedResult[translate('quicksearchcat.manuals')];
    let contentResult = groupedResult[translate('quicksearchcat.pages')];
    let noHitResult = groupedResult.NoHit;
    let showAllResult = groupedResult.ShowAll;

    var totalProductHits = productResult != null && productResult.length > 0 ? productResult[0].total : 0;
    return (
        <div className={isCampaignBannerActive ? "quick-search-result quick-search-result--with-vma" : "quick-search-result"}>
            <div className="row">
                <div className="columns small-12 large-6 large-offset-1">
                    {productResult && productResult.length > 0 &&
                        <div className="quick-search-result__group-header">{productResult[0].category}</div>
                    }
                    <div className="quick-search-result--products">
                        
                        {productResult &&
                            resultRenderer(productResult, selectedItem, searchUrl)
                        }
                        {!productResult && !noHitResult &&
                        <div className="quick-search-result__group-header">{translate('quicksearch.no-product-hits')}</div>
                        }
                    </div>
                    {showAllResult && showAllResult.length > 0 &&
                        <a className="quick-search-result__show-all" href={searchUrl}>{showAllResult[0].name}&nbsp;<span>({totalProductHits})</span></a>
                    }
                    {noHitResult && noHitResult.length > 0 &&
                        <div className="quick-search-result--no-hit">
                            <h3>{noHitResult[0].name}</h3>
                        </div>
                    }
                </div>
                <div className="columns small-12 large-3 large-offset-1">   
                    <ul className="quick-search-result--other">                      
                        {manualsResult &&
                            resultRenderer(manualsResult, selectedItem, searchUrl)
                        }
                        {categoryResult &&
                            resultRenderer(categoryResult, selectedItem, searchUrl)
                        }
                        {contentResult &&
                            resultRenderer(contentResult, selectedItem, searchUrl)
                        }
                    </ul>
                </div>
            </div>
        </div>

    );
};

export default QuickSearchResult;
